(() => {
  const normalizePhone = (value) => {
    const raw = value.trim();
    const digits = raw.replace(/\D/g, "");

    if (raw.startsWith("+") && digits.length >= 10 && digits.length <= 15) {
      return `+${digits}`;
    }

    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;

    return "";
  };

  const splitName = (fullName) => {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 1) {
      return { firstName: parts[0], lastName: "" };
    }

    return {
      firstName: parts.slice(0, -1).join(" "),
      lastName: parts.at(-1)
    };
  };

  document.querySelectorAll("[data-sony-giveaway-form]").forEach((form) => {
    if (form.dataset.giveawayReady === "true") return;
    form.dataset.giveawayReady = "true";

    const submitButton = form.querySelector(".sony-giveaway__submit");
    const status = form.querySelector(".sony-giveaway__status");
    const backupForm = document.getElementById(form.dataset.backupFormId);
    const defaultButtonLabel = submitButton.textContent;

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      if (!form.reportValidity()) return;

      if (form.elements.website.value) {
        status.textContent = "You’re entered. Good luck!";
        return;
      }

      const fullName = form.elements.full_name.value.trim();
      const { firstName, lastName } = splitName(fullName);
      const email = form.elements.email.value.trim();
      const phone = normalizePhone(form.elements.phone_number.value);
      const smsMarketing = form.elements.sms_marketing.checked;

      if (!phone) {
        status.textContent = "Enter a valid mobile number, including area code.";
        form.elements.phone_number.focus();
        return;
      }

      const profileAttributes = {
        first_name: firstName,
        last_name: lastName,
        email,
        phone_number: phone,
        properties: {
          "Full Name": fullName,
          "Sony Summer Bash 2026 Giveaway Entry": true,
          "Giveaway Prize": "Sony Alpha 7 IV Camera",
          "Entry Source": "Pictureline giveaway landing page"
        },
        subscriptions: {
          email: {
            marketing: {
              consent: "SUBSCRIBED"
            }
          }
        }
      };

      if (smsMarketing) {
        profileAttributes.subscriptions.sms = {
          marketing: {
            consent: "SUBSCRIBED"
          }
        };
      }

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Sony Summer Bash 2026 giveaway page",
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: form.dataset.listId
              }
            }
          }
        }
      };

      submitButton.disabled = true;
      submitButton.textContent = "Entering…";
      status.textContent = "";

      try {
        const klaviyoRequest = fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(form.dataset.companyId)}`,
          {
            method: "POST",
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2026-07-15"
            },
            body: JSON.stringify(payload)
          }
        );

        const backupRequest = backupForm
          ? (() => {
              backupForm.elements["contact[email]"].value = email;
              backupForm.elements["contact[first_name]"].value = firstName;
              backupForm.elements["contact[last_name]"].value = lastName;
              backupForm.elements["contact[phone]"].value = phone;

              return fetch(backupForm.action, {
                method: "POST",
                body: new FormData(backupForm),
                headers: { accept: "text/html" }
              });
            })()
          : Promise.reject(new Error("Backup form is unavailable"));

        const [klaviyoResult, backupResult] = await Promise.allSettled([
          klaviyoRequest,
          backupRequest
        ]);
        const klaviyoSaved =
          klaviyoResult.status === "fulfilled" && klaviyoResult.value.ok;
        const backupSaved =
          backupResult.status === "fulfilled" && backupResult.value.ok;

        if (!klaviyoSaved && !backupSaved) {
          throw new Error("Giveaway entry could not be saved");
        }

        if (!klaviyoSaved) console.warn("Sony giveaway: primary save failed");
        if (!backupSaved) console.warn("Sony giveaway: backup save failed");

        form.reset();
        form.classList.add("is-complete");
        status.textContent = "You’re entered! Good luck.";
        submitButton.textContent = "Entry received";
      } catch (error) {
        status.textContent = "We couldn’t save your entry. Please try again in a moment.";
        submitButton.disabled = false;
        submitButton.textContent = defaultButtonLabel;
      }
    });
  });
})();
